import { HStack, Text, Button, WrapItem, Spacer, Wrap } from '@chakra-ui/react';

export interface ObjectsListPaginationProps {
  numberOfPages: number;
  handlePageChange: (number: number) => void;
  currentPage: number;
}

export const ObjectsListPagination = (props: ObjectsListPaginationProps): JSX.Element => {
  const { numberOfPages, handlePageChange, currentPage } = props;

  const pages = Array.from(Array(numberOfPages).keys()).filter(num => num > 0);
  pages.push(numberOfPages);

  const ONE_RANGE_PAGES = 7;

  const PAGES_AWAY_CURRENT_PAGE_FROM_RANGE = 3;
  const CURRENT_PAGE_INDEX = currentPage - 1;

  const startIdxPages = CURRENT_PAGE_INDEX - PAGES_AWAY_CURRENT_PAGE_FROM_RANGE;
  let startIdxPagesProper = 0;
  startIdxPages > 0 &&
    (startIdxPagesProper = CURRENT_PAGE_INDEX - PAGES_AWAY_CURRENT_PAGE_FROM_RANGE);

  const endIdxPages = CURRENT_PAGE_INDEX + PAGES_AWAY_CURRENT_PAGE_FROM_RANGE;
  const endIdxPagesProper = endIdxPages < ONE_RANGE_PAGES ? ONE_RANGE_PAGES - 1 : endIdxPages;

  const minEndIdxRange = pages.length - 1 - PAGES_AWAY_CURRENT_PAGE_FROM_RANGE;
  const isEndIdxBiggerThanMinEndIdxRange = CURRENT_PAGE_INDEX > minEndIdxRange;

  const countHowMuchEndIdxIsBiggerThanMinEndIdxRange =
    isEndIdxBiggerThanMinEndIdxRange && pages.length - 1 > endIdxPagesProper
      ? endIdxPagesProper - minEndIdxRange
      : endIdxPagesProper - minEndIdxRange - PAGES_AWAY_CURRENT_PAGE_FROM_RANGE;
  isEndIdxBiggerThanMinEndIdxRange &&
    (startIdxPagesProper = startIdxPagesProper - countHowMuchEndIdxIsBiggerThanMinEndIdxRange);

  const endIdxPagesProperSliceEnd = endIdxPagesProper + 1;
  const currentRangeOfPages = pages.slice(startIdxPagesProper, endIdxPagesProperSliceEnd);

  return (
    <Wrap bg={'white'} p={4} borderRadius={4} mb={8} alignItems={'baseline'}>
      {numberOfPages > 1 &&
        <>
          <Text>
            Seite {currentPage} von {numberOfPages}
          </Text>
          <Spacer />
          <Wrap mt={2} flexWrap={'wrap'} alignItems={'flex-end'}>
            <WrapItem>
              <Button
                size={'sm'}
                borderColor={'blue.500'}
                color={'blue.500'}
                variant={'outline'}
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}>
                &laquo;
              </Button>
            </WrapItem>
            {currentRangeOfPages.map(page => {
              return (
                <WrapItem key={page}>
                  <Button
                    size={'sm'}
                    borderColor={'blue.500'}
                    bgColor={currentPage === page ? 'blue.100' : '#fff'}
                    color={'blue.500'}
                    variant={'outline'}
                    onClick={() => handlePageChange(page)}>
                    {page}
                  </Button>
                </WrapItem>
              );
            })}
            <WrapItem>
              <Button
                size={'sm'}
                borderColor={'blue.500'}
                color={'blue.500'}
                variant={'outline'}
                onClick={() => handlePageChange(numberOfPages)}
                disabled={currentPage === numberOfPages}>
                &raquo;
              </Button>
            </WrapItem>
          </Wrap>
        </>
      }
    </Wrap>
  );
};
